import { Dialog, DialogContent, DialogTrigger } from "@/components/ui/dialog";
import { Expand, Mail } from "lucide-react";

const galleryImages = [
  { id: 1, imageUrl: "/attached_assets/VCA photos (751) - Copy_1750074778096.jpg" },
  { id: 2, imageUrl: "/attached_assets/VCA photos (359) - Copy_1750074778100.jpg" },
  { id: 3, imageUrl: "/attached_assets/VCA photos (587) - Copy_1750074778094.jpg" },
  { id: 4, imageUrl: "/attached_assets/VCA photos (554) - Copy_1750074778100.JPG" },
  { id: 5, imageUrl: "/attached_assets/VCA photos (562)_1750074778101.jpg" },
  { id: 6, imageUrl: "/attached_assets/VCA photos (589) - Copy_1750074778096.jpg" },
  { id: 7, imageUrl: "/attached_assets/VCA photos (623) - Copy_1750074778096.jpg" },
  { id: 8, imageUrl: "/attached_assets/VCA photos (771) - Copy_1750074778097.jpg" },
  { id: 9, imageUrl: "/attached_assets/VCA photos (51) - Copy_1750074778100.JPG" },
  { id: 10, imageUrl: "/attached_assets/Vaal dam 023 - Copy_1750074778099.jpg" },
  { id: 11, imageUrl: "/attached_assets/IMG-20250612-WA0084 - Copy_1750074778098.jpg" },
  { id: 12, imageUrl: "/attached_assets/IMG-20250612-WA0085 - Copy_1750074778098.jpg" },
  { id: 13, imageUrl: "/attached_assets/IMG-20250612-WA0087 - Copy_1750074778098.jpg" },
  { id: 14, imageUrl: "/attached_assets/IMG-20250612-WA0089 - Copy_1750074778099.jpg" },
  { id: 15, imageUrl: "/attached_assets/IMG-20250805-WA0104_1763731855651.jpg" },
  { id: 16, imageUrl: "/attached_assets/IMG-20250805-WA0106_1763731890131.jpg" },
  { id: 17, imageUrl: "/attached_assets/IMG-20250818-WA0033_1763731893717.jpg" },
  { id: 18, imageUrl: "/attached_assets/IMG-20250818-WA0038_1763731862788.jpg" },
  { id: 19, imageUrl: "/attached_assets/IMG-20250818-WA0046_1763731864605.jpg" },
  { id: 20, imageUrl: "/attached_assets/IMG-20250903-WA0098_1763731873241.jpg" },
  { id: 21, imageUrl: "/attached_assets/WhatsApp Image 2025-06-17 at 16.45.47_cd34f787_1750174448763.jpg" },
  { id: 22, imageUrl: "/attached_assets/hero_1750152204984.jpg" },
];

export default function Gallery() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="mb-6">
            <span className="inline-block px-4 py-2 rounded-full bg-sailing-gold/10 text-sailing-gold font-medium text-sm mb-4">
              Our Memories
            </span>
          </div>
          <h1 className="text-5xl font-bold text-navy mb-6">Gallery</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">Capturing our boating adventures and community moments</p>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mb-16">
          {galleryImages.map((image) => (
            <Dialog key={image.id}>
              <DialogTrigger asChild>
                <div className="group cursor-pointer relative overflow-hidden rounded-2xl card-modern">
                  <img
                    src={image.imageUrl}
                    alt="VCA Gallery Image"
                    className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-300"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-all duration-300"></div>
                  <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300">
                    <div className="bg-white/20 backdrop-blur-sm rounded-full p-3">
                      <Expand className="text-white h-6 w-6" />
                    </div>
                  </div>
                </div>
              </DialogTrigger>
              <DialogContent className="max-w-4xl">
                <img
                  src={image.imageUrl}
                  alt="VCA Gallery Image"
                  className="w-full h-auto max-h-[80vh] object-contain rounded-xl"
                />
              </DialogContent>
            </Dialog>
          ))}
        </div>

        {/* Upload Section */}
        <div className="bg-navy rounded-3xl p-12 text-white">
          <div className="text-center">
            <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-2xl flex items-center justify-center mx-auto mb-6">
              <Mail className="h-8 w-8 text-white" />
            </div>
            <h2 className="text-3xl font-bold mb-4 text-white">Share Your Photos</h2>
            <p className="text-xl mb-8 text-white max-w-2xl mx-auto">
              Have great boating photos from VCA events? We'd love to feature them in our gallery! Send high resolution photos to <span className="font-semibold text-sailing-gold">web@vaalcruising.co.za</span>
            </p>
            <a
              href="mailto:web@vaalcruising.co.za?subject=Gallery Photo Submission"
              className="inline-flex items-center bg-sailing-gold hover:bg-sailing-gold-light text-navy font-semibold py-4 px-8 text-lg rounded-xl shadow-lg transition-colors"
            >
              <Mail className="mr-3 h-5 w-5" />
              Send Photos via Email
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
